import {
    Typography,
    Grid,
    Button,
    Box,
    TextField,
    IconButton,
    InputAdornment,
    CircularProgress,
    alpha,
    Alert,
    Snackbar,
    createTheme,
    Dialog,
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import {
    Visibility,
    VisibilityOff,
    Login as LoginIcon,
  } from "@mui/icons-material";
import axios from "axios";
  
  const ForgotPasswordPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [password, setPassword] = useState<string | undefined>(undefined);
    const [confirmPassword, setConfirmPassword] = useState<string | undefined>(undefined);
    const [showPasswordResetPassword, setShowPasswordResetPassword] = useState(false);
    const [showPasswordDoubleResetPassword, setShowPasswordDoubleResetPassword] = useState(false);
    const [error, setError] = useState<string | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [NotValid, setNotValid] = useState<string | null>(null);
    const [Valid, setValid] = useState<boolean | null>(null);
    const [errorResetPassword, setErrorResetPassword] = useState<boolean | null>(null);
    const [errorConfirmResetPassword, setErrorConfirmResetPassword] = useState<boolean | null>(null);

    const [errorhelperText, setErrorHelperText] = useState<string | null>(null);

    const token = window.location.pathname.split("reset-password/").pop();

    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredConfirmPassword, setIsHoveredConfirmPassword] = useState(false);
    

    const navigate = useNavigate();
    
    const EnterKeyOnClickResetPassword = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        handleResetPassword();
      }
    };

    const handleResetPassword = async () => {
      try {
        await setIsLoading(true);
        setError(null);
        setErrorResetPassword(null);
        setErrorConfirmResetPassword(null);

        var errorMsg = "";
        if(password === undefined || password === ""){errorMsg = errorMsg + "Please enter password.\n 請輸入密碼。 \n"}
        if(errorhelperText !== null){
          errorMsg += errorhelperText
        }

        if(errorMsg !== ""){
          setError(errorMsg)
          if(errorMsg.includes("enter password")){
            setErrorResetPassword(true)
          }
          setIsLoading(false);
        }
        else if(errorhelperText !== null){
          setError(errorhelperText);
          setErrorConfirmResetPassword(true);
          setIsLoading(false);
        }else{
          axios.post(`${process.env.REACT_APP_BASE_URL}/api/Account/password/reset`, {token: token, password: password}).then((response)=>{
                  if (response.status !== 200){
                      setError(response.data);
                      setErrorResetPassword(true)
                      setErrorConfirmResetPassword(true);
                      setIsLoading(false);
                  }else{
                    setOpenResetPasswordSuccess(true);
                    setIsLoading(false);
                  }
              }).catch((ex: any)=>{
                setError(ex.response.data);
                setErrorResetPassword(true)
                setErrorConfirmResetPassword(true);
                setIsLoading(false);
              })
          
        }
      } catch (ex: any) {
        setError(
          ex.data?.message || "Password reset failed. \n 密碼重置失敗 \n"
        );
        setErrorResetPassword(true)
        setErrorConfirmResetPassword(true);
        setIsLoading(false);
      }
    };


    const theme = createTheme({
        palette: {
            primary: {
                main: '#2e7d32',
              },
        },
      });

    useEffect(() => {
      const checkRefreshToken = async () => {
        try {
          const rt = localStorage.getItem("refreshToken");
          if (rt) {
            await setIsLoading(true);
          }
        } catch (ex) {
          console.error(ex);
        } finally {
          setIsLoading(false);
        }
      };
  
      checkRefreshToken();
    }, [navigate]);


    useEffect(() => {
      try {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/Account/password/checkTokenValid/${token}`).then((response)=>{
                if (response.status !== 200){
                    setNotValid(response.data);
                }else{
                    setNotValid(null);
                    setValid(true);
                }
            }).catch((ex: any)=>{
                setNotValid(ex.response.data);
            })
          
      } catch (ex: any) {
        setNotValid(
          ex.data?.message || "Token is not valid. \n 令牌無效 \n"
        );
      }
    }, [token]);


    const [openResetPasswordSuccess, setOpenResetPasswordSuccess] = useState(false);

    useEffect(()=>{
      if (confirmPassword !== password){
        setErrorHelperText("Password reentered is not equal to the password in password field \n 密碼欄位中的密碼不相同 \n")
      }else{
        setErrorHelperText(null);
      }
    }
    ,[confirmPassword, password])

    return (
      Valid == null ? <p>{"Token is not valid. \n 令牌無效 \n"}</p> :
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        <Grid
          container
          spacing={0}
          direction={{ xs: "column", md: "column", lg: "row" }}
          sx={{
            maxWidth: { xs: "450px", sm: "450px", md: "450px", lg: "500px" },
            width: "100%",
            margin: "0 auto",
            borderRadius: { xs: 0, lg: 2 },
            overflow: "hidden",
            backgroundColor: theme.palette.background.paper,
            minHeight: { xs: "80vh", lg: "70vh" },
            boxShadow: { lg: theme.shadows[4] },
          }}
        >
          {/* Login Form Section */}
          <Grid
            item
            xs={12}
            lg={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: { xs: 3, sm: 4, md: 5, lg: 6 },
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 400 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                  textAlign: "center",
                  mb: { xs: 2, sm: 3 },
                }}
              >
                Reset Password
              </Typography>
              <form noValidate>
              <TextField
                autoComplete="new-password"
                label="Password"
                type={showPasswordResetPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyUp={EnterKeyOnClickResetPassword}
                fullWidth
                variant="outlined"
                error={!!errorResetPassword}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                disabled={isLoading}
                InputLabelProps={{ shrink: true }}  
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswordResetPassword(!showPasswordResetPassword)}
                        edge="end"
                        sx={{  color: isHovered ? theme.palette.primary.main : ""}}
                      >
                        {showPasswordResetPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 3, sm: 4 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <TextField
                autoComplete="new-password"
                label="Confirm Password"
                type={showPasswordDoubleResetPassword ? "text" : "password"}
                onChange={(e) => {
                  setConfirmPassword(e.target.value)
                }}
                onKeyUp={EnterKeyOnClickResetPassword}
                onMouseEnter={() => setIsHoveredConfirmPassword(true)}
                onMouseLeave={() => setIsHoveredConfirmPassword(false)}
                fullWidth
                variant="outlined"
                error={!!errorhelperText || !!errorConfirmResetPassword}
                disabled={isLoading}
                InputLabelProps={{ shrink: true }}  
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswordDoubleResetPassword(!showPasswordDoubleResetPassword)}
                        edge="end"
                        sx={{  color: isHoveredConfirmPassword ? theme.palette.primary.main : ""}}
                      >
                        {showPasswordDoubleResetPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 3, sm: 4 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={handleResetPassword}
                disabled={isLoading}
                fullWidth
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <LoginIcon />
                  )
                }
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                  "&:disabled": {
                    background: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabled,
                  },
                }}
              >
                {isLoading ? <CircularProgress/> : "Reset Password"}
              </Button>
              </form>
            </Box>
          </Grid>
        </Grid>
  
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setError(null)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            <Typography variant="body2">
              {error && error!.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            </Typography>
          </Alert>
        </Snackbar>
      
      

      <Dialog
        open={openResetPasswordSuccess}
      >

              <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 700 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}>
              <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    letterSpacing: { xs: 1, sm: 2 },
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Success
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    mt: { xs: 1, sm: 2 },
                    fontWeight: 300,
                    opacity: 0.9,
                    textAlign: "center",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                密碼已重設。<br></br><br></br>

                Password is reset.
                </Typography>
                <div className="mb-3"></div>
                <Button
                variant="contained"
                onClick={()=>{setOpenResetPasswordSuccess(false); navigate("/")}}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                }}
              >
                Close
              </Button>
              </Box>

      </Dialog>



      {(isLoading) && <div style={{position:"fixed", left:"0", top:"0", width:"100%", height:"100%", zIndex:"100", background:"rgba(0, 0, 0, 0.4)"}}></div>}
      
      </Box>






      

    );
  };
  
  export default ForgotPasswordPage;
  